import {segment, formatSubmittedItems} from './helpers'

export const completedExchangeRequest = (orderId) =>
  segment('Completed Exchange Request', {orderId})

export const submittedItemsExchangeRequest = (allSelectedItemsToExchangeDetails, orderId) => {
  const props = formatSubmittedItems(allSelectedItemsToExchangeDetails, orderId)
  segment('Submitted Items Exchange Form', props)
}
